import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import type { CommentRole } from '@change-corgi/middle-end-gql-schema';

import type {
	StarterDashboardV2RootPageDataQuery,
	StarterDashboardV2RootPageDataQueryVariables,
} from '../rootPageData.graphql';
import { StarterDashboardV2RootPageData } from '../rootPageData.graphql';

export async function getStarterRootPageData(
	fetch: UtilityContext['gql']['fetch'],
	{
		slug,
		completedSince,
		locale,
		countryCode,
		emailEnabled,
		includePetitionUpdatesInfo = true,
		commentsRoles,
	}: {
		slug: string;
		completedSince: string;
		locale: string;
		countryCode: string;
		emailEnabled: boolean;
		includePetitionUpdatesInfo?: boolean;
		commentsRoles: readonly CommentRole[];
	},
) {
	return fetch<StarterDashboardV2RootPageDataQuery, StarterDashboardV2RootPageDataQueryVariables>({
		query: StarterDashboardV2RootPageData,
		variables: {
			slug,
			completedSince,
			locale,
			countryCode,
			emailEnabled,
			includePetitionUpdatesInfo,
			skipShareVisuals: true, // Prevents on-demand generation for petitions outside the feature flag scope. TODO: Conditionally add this based on the FCM
			commentsRoles,
		},
		rejectOnError: true,
	});
}
